/**
 *
 * @param name
 * @param value
 * @param expireHours
 */
export function setCookie(name, value, expireHours = null) {
	let expires = '';

	if(expireHours) {
		const today = new Date();
		today.setTime(today.getTime() + (expireHours*60*60*1000));
		expires = "expires="+ today.toUTCString() + ";";
	}

	document.cookie = name + "=" + value + ";" + expires + "path=/";
}